import React from 'react';
import styled from 'styled-components';
import { string } from 'prop-types';

const AdPriceText = styled.p`
  margin-top: 5px;
  font-size: 14px;
  text-align: center;
  color: #999999;
`;

const AdPrice = ({ text }) => (
  <AdPriceText>{text}</AdPriceText>
);

export default AdPrice;

AdPrice.propTypes = {
  text: string.isRequired,
};
